module.exports = __webpack_public_path__ + "static/img/9.6f3739d5.png";